import { He6UltraDeviceList } from '@/define/device_vendor'
import { DeviceProtocolBase } from './device_model'
import { VirtualFE87V2_MuYan } from '@hid/define/define'

export class DeviceWeb implements DeviceProtocolBase {
  // private device: HIDDevice | null = null
  private fnOnReceive: ((data: number[]) => void) | null = null
  private reportID = 0
  private disposed = false

  onReceive(fn: (data: number[]) => void) {
    this.fnOnReceive = fn
  }

  constructor(private device: HIDDevice) {}

  async send(data: number[]): Promise<void> {
    if (this.disposed || !this.device) return
    // 必须把 sendReport 的 Promise 返回出去，让上层 processQueue 能 await 真实的发送完成；
    // 一旦发送失败（例如设备物理拔出后的 InvalidStateError），错误也要冒泡给调度器，
    // 而不是像旧实现那样在异步 catch 里 throw new Error(e) —— 那样会变成未处理的
    // promise rejection 并被吞掉，同时调度器仍会错误进入“等回包 → 超时”分支。
    return this.device.sendReport(this.reportID, new Uint8Array(data))
  }

  async sendFeature(data: number[]): Promise<void> {
    if (this.disposed || !this.device) return
    await this.device.sendFeatureReport(this.reportID, new Uint8Array(data))

    // 立刻读回 feature report；不再 setTimeout(1ms)，让回包尽快进入 task-local resolver。
    // 用 microtask（不 await）把读取放到下一个 tick，避免阻塞 processQueue 把控制权交回，
    // 否则在固件未就绪时这次读取会失败、整个 sendFeature 就要 reject 一并报错。
    queueMicrotask(() => {
      if (this.disposed || !this.device) return
      this.device
        .receiveFeatureReport(this.reportID)
        .then((e) => {
          if (this.disposed || !this.fnOnReceive) return
          const bytes = Array.from(new Uint8Array(e.buffer))
          this.fnOnReceive(bytes)
        })
        .catch((err) => {
          // \u8bfb\u53d6\u5931\u8d25\u4e0d\u5e94\u8ba9 sendFeature \u672c\u8eab\u51fa\u9519\uff0c\u7531\u8c03\u5ea6\u5668\u8d85\u65f6\u673a\u5236\u5151\u5e95\u3002
          console.warn('receiveFeatureReport error:', err)
        })
    })
  }

  async connect(): Promise<boolean> {
    if (!this.device) return false
    if (this.device.opened == false) {
      await this.device.open().catch((error) => {
        console.error('open error:', error)
        return false
      })
    }
    const device = (this.device.vendorId << 16) | this.device.productId
    if (He6UltraDeviceList.includes(device)) {
      this.reportID = 0x08
    }
    if (VirtualFE87V2_MuYan == device) {
      this.reportID = 0x06
    }
    console.log('connect:', this.device)
    this.device.oninputreport = (e) => {
      if (this.disposed || !this.fnOnReceive) return
      const bytes = Array.from(new Uint8Array(e.data.buffer))
      // printHex(bytes, "r")
      this.fnOnReceive(bytes)
    }
    return true
  }

  // dispose 必须把绑在 HIDDevice 上的回调主动解开。HIDDevice 实例可能在重新 requestDevice 时被
  // 浏览器复用，旧的 oninputreport 仍指向旧 DeviceWeb 的 fnOnReceive，会让回包串到新驱动上。
  dispose(): void {
    this.disposed = true
    this.fnOnReceive = null
    if (this.device) {
      this.device.oninputreport = null
    }
  }

  initDevice = async () => {}
}
